import React, { useEffect, useRef, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import CguContent from "@/components/price/CguContent";

// Lecture complète obligatoire puis case + « Accepter et continuer ».
export default function CguScrollAccept({ version, onAccept, onRefuse, refuseLabel = "Je refuse", title = "Conditions Générales d'Utilisation", intro, testid = "cgu-gate" }) {
  const box = useRef(null);
  const [atEnd, setAtEnd] = useState(false);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  const onScroll = () => {
    const el = box.current;
    if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 32) setAtEnd(true);
  };
  useEffect(() => { onScroll(); }, []);

  const accept = async () => {
    setBusy(true);
    try { await onAccept(); } finally { setBusy(false); }
  };

  return (
    <>
      <div className="border-b-2 border-foreground/10 p-5">
        <div className="flex items-center gap-2 font-[Outfit] text-[20px] font-black leading-tight"><FileText className="h-5 w-5" />{title}</div>
        <p className="mt-1 text-[13px] font-semibold text-foreground/70" data-testid={`${testid}-version`}>
          Version {version.version} — {intro || "lis-les jusqu'en bas puis accepte-les pour continuer."}
        </p>
        {version.summary && <p className="mt-2 rounded-xl bg-[#FFE9D6] px-3 py-2 text-[12px] font-bold" data-testid={`${testid}-summary`}>Ce qui change : {version.summary}</p>}
      </div>
      <div ref={box} onScroll={onScroll} className="flex-1 overflow-y-auto overscroll-contain px-5 pb-4" data-testid={`${testid}-scroll`}>
        <CguContent content={version.content} testid={`${testid}-content`} />
      </div>
      <div className="space-y-2 border-t-2 border-foreground/10 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
        {!atEnd && <p className="text-center text-[12px] font-bold text-foreground/60" data-testid={`${testid}-scroll-hint`}>Fais défiler jusqu&apos;à la fin pour pouvoir accepter.</p>}
        <label className={`flex items-start gap-2 text-[13px] font-bold ${atEnd ? "" : "opacity-40"}`}>
          <input type="checkbox" disabled={!atEnd} checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#1E0910]" data-testid={`${testid}-checkbox`} />
          J&apos;ai lu et j&apos;accepte les Conditions Générales d&apos;Utilisation de Price Covoit.
        </label>
        <button type="button" disabled={!atEnd || !checked || busy} onClick={accept}
          className="street-press flex h-12 w-full items-center justify-center gap-2 rounded-full bg-primary font-[Outfit] font-black text-primary-foreground street-border street-shadow-sm disabled:opacity-50"
          data-testid={`${testid}-accept`}>
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Accepter et continuer
        </button>
        {onRefuse && (
          <button type="button" onClick={onRefuse} className="h-10 w-full rounded-full text-[13px] font-black text-foreground/60 underline-offset-2 hover:underline" data-testid={`${testid}-refuse`}>
            {refuseLabel}
          </button>
        )}
      </div>
    </>
  );
}
